import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import CustomButton from "../../../components/ui/CustomButton";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setState } from "../../../store/loginSlice";

const baseApiUrl = process.env.REACT_APP_API_URL;

export const SignInButton = () => {
  const { instance, inProgress, accounts } = useMsal();
  const [profile, setProfile] = useState(null);
  const dispatch = useDispatch();

  /**
   * 🔐 Acquire token silently AFTER redirect login succeeds
   */
  useEffect(() => {
  if (inProgress !== InteractionStatus.None) return;

  const accounts = instance.getAllAccounts();

  if (accounts.length === 0) return;

  const account = accounts[0];
  instance.setActiveAccount(account);

  instance
    .acquireTokenSilent({
      scopes: ["User.Read"],
      account,
    })
    .then((response) => {
      console.log("✅ Token acquired silently:", response.accessToken);
      console.log("👤 User info:", response.account);
      console.log("📅 Token expiration:", response.expiresOn);
      console.log("🔐 Scopes granted:", response.scopes);
      console.log("🔍 ID token claims:", response.idTokenClaims);
      console.log("🛡️ Token type:", response.tokenType);
      console.log("📊 Account home tenant ID:", response.account.tenantId);
      console.log("📁 Account username:", response.account.username);
      console.log("📌 Account local account ID:", response.account.localAccountId);
      console.log("📎 Account environment:", response.account.environment);
      console.log("📂 Account name:", response.account.unique_name);
      console.log("📎 Account ID token claims:", response.account.upn);
       let uri1 = JSON.stringify(response.accessToken);
			let obj1 = {
				type: "Info",
				info: "Access Token:",
				jsonlist: uri1,
			};
			Logging(obj1);
		  const account = response.account;
		  let uri2 = JSON.stringify(response.account);
		  let obj2 = {
			  type: "Info",
			  info: "account:",
			  jsonlist: uri2,
		  };
		  Logging(obj2);
		  console.log("Email ID:", account.username);
      //navigate to dashboard page
      if(account.username != null && account.username !== undefined){
        console.log("Navigating to dashboard with email:", response.account.username);
        GetUserDetails(response.account.username);
        console.log("Email ID sent to backend for user details lookup:", response.account.username);
      }
      else{
        console.warn("⚠️MSAL No username found in account info.");
      }
    })
    .catch((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        console.warn("⚠️ Interaction required, user must sign in again.");
         instance.acquireTokenRedirect({   
            scopes: ["User.Read"],
            account,
          });

      } else {
        console.error("❌ Silent token error:", error);
      }
    });

}, [inProgress, accounts,instance]);

  /**
   * 🔑 Redirect Login
   */

  const Logging = async (obj) => {
		try {
		   // Make the POST request
		   let url = baseApiUrl + "Home/Logging";
		  //  const response = await fetch(url, {
			//   method: "POST",
			//   headers: {
			// 	 "Content-Type": "application/json",
			//   },
			//   body: JSON.stringify(obj),
		  //  });
	 
		   // Parse the response
		  // const result = await response.json();

      console.log("Logging object sent to backend:", obj);
	 
		   // Set the response in the state
		} catch (error) {
		   console.error("Error making POST request:", error);
		}
	 };
  
   const handleLogin = async () => {
    if (inProgress !== InteractionStatus.None) return;

    await instance.loginRedirect({
      scopes: ["User.Read"],
    });    

  };


  /**
   * 🧠 Backend get the userdeatils lookup
   */
  const GetUserDetails = (username) => {
		
    try{

    
    const baseUrl = baseApiUrl+`SSOLogin?email=`+username;
		axios
		  .get(baseUrl, {
		  })
		  .then((response) => {
			if( response !== undefined && response !== null &&response?.data !== 'not exist'){
				let uri4 = JSON.stringify(response?.data);
				let obj4 = {
					type: "Info",
					info: "Login error:",
					jsonlist: uri4,
				};
				Logging(obj4);
        console.log("User details response from backend:", response?.data);
			  //if(email !== response?.data?.email){
				localStorage.setItem("data", JSON.stringify(response?.data));
				window.location.replace(window.location.origin+'/dashboard');
				dispatch(setState("isLoggedIn", true));
			  //}
			}
		  });
    }
    catch(error){
      console.error("Error fetching user details from backend:", error);
      let uri3 = JSON.stringify(error);
      let obj3 = {
        type: "Error",
        info: "Error fetching user details:",
        jsonlist: uri3,
      };
      Logging(obj3);
    }
   

	  };

  return (
    <CustomButton onClick={handleLogin}>
      Login with Azure AD
    </CustomButton>
  );
};